var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('iframe',{staticClass:"responsive-iframe",staticStyle:{"min-height":"96vh"},attrs:{"src":_vm.url,"id":"itab"}})])}
var staticRenderFns = []

export { render, staticRenderFns }